import Joi from "joi";
import React from "react";
import { Link } from "react-router-dom";
import Form from "../../common/form.jsx";
import { IoMdTrash } from "react-icons/io";
import {
  Panel,
  PanelBody,
  PanelHeader,
} from "../../components/panel/panel.jsx";
import auth from "../../services/authservice";
import { getWorkinstruction, saveWorkinstruction } from "./../../services/workinstructions";
import { getCompany } from "./../../services/companies";
import { getCompanys } from "./../../services/companies";
import withRouter from "../../common/withRouter.jsx";
import { toast } from "react-toastify";
import Select from "react-select";
import { connect } from 'react-redux';
import { getCurrentUser, loadCurrentUser } from '../../store/users';
import Editor from "../../components/common/Editor"

class WorkInstruction extends Form {
  constructor(props) {
    super(props);

    this.state = {
      data: {
        user: auth.getProfile()._id,
        businessNo: "", // Will be populated when editing existing work instruction
        deployTo: [],
        department: "",
        description: "",
        name: "",
        version: "",
        tags: "",
        copyright: "",
        language: "English", // Set English as default
        actions: [{ name: "", step: "1" }], // Always start with one action
        note: "",
        status: "active"
      },
      company: null,
      companies: [],
      deployToOptions: [],
      errors: {},
      isSubmitting: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }


  async populateCompanies() {
    // Keeping method for backward compatibility
    try {
      const { data: companies } = await getCompanys();
      this.setState({ companies });
      if (this.props.currentUser.role?.name === "Company") {
        const { data: company } = await getCompany(this.props.currentUser.accountNo);
        this.setState({ company: company[0] });
        if (company[0].isMaster === true) {
          const deployToOptions = companies.map((el) => ({
            value: el._id,
            label: `${el?.companies.username}`,
            avatar: el?.companies.imageSrc,
          }));
          console.log("deployToOptions", deployToOptions);
          this.setState({ deployToOptions: deployToOptions });
        }
      }
    } catch (ex) {
      // Handle silently
    }
  }



  async populateWorkInstruction() {
    try {
      const workInstructionId = this.props.params?.id;
      if (workInstructionId === "new") return;
      const { data: workInstruction } = await getWorkinstruction(workInstructionId);
      this.setState({ data: this.mapToViewModel(workInstruction) });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.navigate("/error");
    }
  }

  async componentDidMount() {
    // Load current user from Redux like supervisor.js does
    document.title = "Add WorkInstruction";
    //if (this.props.currentUser.role?.name === "Company") await this.populateCompanies(); 
    await this.populateCompanies();
    const userProfile = auth.getProfile();
    if (userProfile?._id) {
      this.props.loadCurrentUser(userProfile._id);
    }


    //await this.populateDeployTo();


    await this.populateWorkInstruction();

  }



  schema = Joi.object({
    name: Joi.string().required(),
    department: Joi.string().optional().allow('', null),
    description: Joi.string().optional().allow('', null),
    tags: Joi.string().optional().allow('', null),
    copyright: Joi.string().optional().allow('', null),
    version: Joi.string().optional().allow('', null),
    language: Joi.string().required(),
    actions: Joi.array().optional(),
    deployTo: Joi.array().optional(),
    note: Joi.string().optional().allow('', null)
  });

  validate = () => {
    const { data } = this.state;
    const errors = {};

    if (!data.name || data.name.trim() === '') {
      errors.name = '"Name" is required';
    }

    if (!data.language || data.language.trim() === '') {
      errors.language = '"Language" is required';
    }

    return Object.keys(errors).length === 0 ? null : errors;
  };

  handleMultiChange = (name, options) => {
    const data = { ...this.state.data };
    data[name] = options.map((o) => o.value);
    console.log(
      "options",
      options.map((o) => o.value)
    );
    this.setState({ data });
  };


  doSubmit = async () => {
    try {
      this.setState({ isSubmitting: true });

      // Clean actions
      const cleanActions = this.state.data.actions.map(action => ({
        name: action.name || '',
        step: action.step || ''
      }));

      // Get businessNo from logged-in user's accountNo if role is Company (using Redux)
      const userProfile = auth.getProfile();

      const submissionData = {
        user: userProfile._id,
        department: this.state.data.department || '',
        deployTo: this.state.data.deployTo || [],
        name: this.state.data.name || '',
        description: this.state.data.description || '',
        tags: this.state.data.tags || '',
        copyright: this.state.data.copyright || '',
        version: this.state.data.version || '',
        language: this.state.data.language || '',
        actions: cleanActions,
        note: this.state.data.note || '',
        status: 'active',
        createdOn: new Date(),
        editedOn: new Date(),
      };

      // For editing: preserve existing businessNo, for new: use current user's accountNo if Company role
      const isEditing = !!this.state.data._id;

      if (isEditing && this.state.data.businessNo) {
        // When editing, preserve existing businessNo (extract ID if it's an object)
        submissionData.businessNo = typeof this.state.data.businessNo === 'object'
          ? this.state.data.businessNo._id
          : this.state.data.businessNo;
      } else if (!isEditing) {
        // For new work instructions, use Redux currentUser.accountNo if role is Company
        const currentUser = this.props.currentUser;
        const isCompanyRole = (currentUser?.roleName === "Company") ||
          (currentUser?.role === "Company") ||
          (currentUser?.role?.name === "Company");

        if (currentUser && isCompanyRole && currentUser?.accountNo) {
          submissionData.businessNo = currentUser.accountNo;
        }
        // No fallback - let backend handle it if no accountNo
      }

      if (isEditing) {
        submissionData._id = this.state.data._id;
      }

      await saveWorkinstruction(submissionData);

      // Show success toast
      if (isEditing) {
        toast.success("Work instruction updated successfully!");
      } else {
        toast.success("Work instruction created successfully!");
      }

      this.props.navigate("/workinstructions/workinstructions");
    } catch (ex) {
      this.setState({ isSubmitting: false });

      // Show error toast
      toast.error("Failed to save work instruction. Please try again.");

      if (ex.response) {
        const errors = {};
        if (ex.response.data && typeof ex.response.data === 'string') {
          const path = ex.response.data.split('"')[1];
          if (path) {
            errors[path] = ex.response.data;
          } else {
            errors.general = ex.response.data;
          }
        } else if (ex.response.data && ex.response.data.message) {
          errors.general = ex.response.data.message;
        } else {
          errors.general = 'An error occurred while saving the work instruction.';
        }
        this.setState({ errors });
      } else {
        this.setState({
          errors: {
            general: 'Network error. Please check your connection and try again.'
          }
        });
      }
    }
  };

  mapToViewModel(WorkInstruction) {
    let actions = [];
    if (WorkInstruction.actions && Array.isArray(WorkInstruction.actions) && WorkInstruction.actions.length > 0) {
      actions = WorkInstruction.actions;
    } else {
      // Always ensure at least one empty action is present
      actions = [{ name: "", step: "1" }];
    }

    // Note: businessNo is preserved from existing data when editing
    return {
      _id: WorkInstruction._id,
      user: WorkInstruction.user || auth.getProfile()._id,
      businessNo: WorkInstruction.businessNo, // Preserve existing businessNo for editing
      department: WorkInstruction.department || '',
      name: WorkInstruction.name || '',
      description: WorkInstruction.description || '',
      version: WorkInstruction.version || '',
      tags: WorkInstruction.tags || '',
      copyright: WorkInstruction.copyright || '',
      actions: actions,
      language: WorkInstruction.language || '',
      deployTo: WorkInstruction.deployTo || [],
      note: WorkInstruction.note || '',
      status: WorkInstruction.status || 'active'
    };
  }

  addAction = () => {
    const nextStepNumber = (this.state.data.actions.length + 1).toString();
    const newAction = { name: "", step: nextStepNumber }; // Auto-increment step number
    this.setState({
      data: {
        ...this.state.data,
        actions: [...this.state.data.actions, newAction]
      }
    });
  };

  removeAction = (index) => {
    const actions = [...this.state.data.actions];
    actions.splice(index, 1);

    // Renumber all steps sequentially after removal
    const renumberedActions = actions.map((action, idx) => ({
      ...action,
      step: (idx + 1).toString()
    }));

    this.setState({
      data: {
        ...this.state.data,
        actions: renumberedActions
      }
    });
  };

  handleActionChange = (index, field, value) => {
    const actions = [...this.state.data.actions];
    actions[index][field] = value;
    this.setState({
      data: {
        ...this.state.data,
        actions: actions
      }
    });
  };

  render() {
    const { errors, data, company, companies, deployToOptions } = this.state;
    console.log("WorkInstruction data", data);
    console.log("companies", companies);
    console.log("deployToOptions", deployToOptions);
    return (
      <React.Fragment>
        <div>
          <ol className="breadcrumb float-xl-right">
            <li className="breadcrumb-item">
              <Link to="/workinstructions">WorkInstructions</Link>
            </li>
            <li className="breadcrumb-item active">Add Work Instruction</li>
          </ol>
          <h1 className="page-header">
            Add WorkInstruction
          </h1>

          <div className="row">
            <div className="col-xl-10">
              <Panel>
                <PanelHeader>Add WorkInstruction</PanelHeader>
                <PanelBody className="panel-form">
                  <div className="alert alert-info mb-3">
                    <strong>Creating work instruction for:</strong><br />
                    User: {auth.getProfile().username || auth.getProfile().email || 'Current User'}<br />
                    {auth.getProfile().role?.name === 'Company' && (auth.getProfile().companyId || auth.getProfile().company?._id) && (
                      <span>Business: Auto-assigned from your company</span>
                    )}
                  </div>

                  <form className="form-horizontal form-bordered" onSubmit={this.handleSubmit}>
                    {errors.general && (
                      <div className="alert alert-danger mb-3">
                        {errors.general}
                      </div>
                    )}

                    <div className="form-group row">
                      <label className="col-lg-2 col-form-label">Language *</label>
                      <div className="col-lg-4">
                        <select
                          className="form-control"
                          name="language"
                          value={data.language}
                          onChange={this.handleChange}
                        >
                          <option value="">Select Language</option>
                          <option value="English">English</option>
                          <option value="普通话">普通话</option>
                          <option value="Español">Español</option>
                          <option value="日本語">日本語</option>
                          <option value="हिन्दी">हिन्दी</option>
                          <option value="Deutsch">Deutsch</option>
                          <option value="اَلْعَرَبِيَّةُ">اَلْعَرَبِيَّةُ</option>
                          <option value="Français">Français</option>
                          <option value="Italiano">Italiano</option>
                          <option value="한국어">한국어</option>
                          <option value="Tiếng Việt">Tiếng Việt</option>
                          <option value="русский язык">русский язык</option>
                          <option value="Português">Português</option>
                          <option value="Türkçe">Türkçe</option>
                          <option value="Nederlands">Nederlands</option>
                          <option value="Svenska">Svenska</option>
                          <option value="Limba română">Limba română</option>
                          <option value="Język polski">Język polski</option>
                          <option value="українська мова">українська мова</option>
                        </select>
                        {errors.language && (
                          <div className="alert alert-danger mt-1">{errors.language}</div>
                        )}
                      </div>
                      <label className="col-lg-2 col-form-label">Name *</label>
                      <div className="col-lg-4">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Name"
                          name="name"
                          value={data.name}
                          onChange={this.handleChange}
                        />
                        {errors.name && (
                          <div className="alert alert-danger mt-1">{errors.name}</div>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-lg-2 col-form-label">Department</label>
                      <div className="col-lg-4">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Department"
                          name="department"
                          value={data.department}
                          onChange={this.handleChange}
                        />
                        {errors.department && (
                          <div className="alert alert-danger mt-1">{errors.department}</div>
                        )}
                      </div>
                      <label className="col-lg-2 col-form-label">Version</label>
                      <div className="col-lg-4">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter version"
                          name="version"
                          value={data.version}
                          onChange={this.handleChange}
                        />
                        {errors.version && (
                          <div className="alert alert-danger mt-1">{errors.version}</div>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-lg-2 col-form-label">Description</label>
                      <div className="col-lg-10">
                        <textarea
                          className="form-control"
                          placeholder="Enter description"
                          name="description"
                          value={data.description}
                          onChange={this.handleChange}
                          rows="3"
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-lg-2 col-form-label">Tags</label>
                      <div className="col-lg-10">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter tags"
                          name="tags"
                          value={data.tags}
                          onChange={this.handleChange}
                        />
                        {errors.tags && (
                          <div className="alert alert-danger mt-1">{errors.tags}</div>
                        )}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-lg-2 col-form-label">Copyrights</label>
                      <div className="col-lg-10">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Copyrights by ....."
                          name="copyright"
                          value={data.copyright}
                          onChange={this.handleChange}
                        />
                        {errors.opyright && (
                          <div className="alert alert-danger mt-1">{errors.copyright}</div>
                        )}
                      </div>

                    </div>

                    <div className="form-group row">
                      <label className="col-lg-2 col-form-label">Actions</label>
                      <div className="col-lg-10">
                        <button
                          type="button"
                          className="btn btn-success btn-sm mb-3"
                          onClick={this.addAction}
                        >
                          Add Action
                        </button>
                        {this.state.data.actions.map((action, index) => (
                          <div key={index} className="card mb-3">
                            <div className="card-body">
                              <div className="form-group row">
                                <div className="col-lg-9">
                                  <label className="form-label">Action</label>

                                  <Editor
                                    initialContent={action.name}
                                    onChangeHandler={(value) => this.handleActionChange(index, 'name', value)}
                                  />
                                </div>
                                {/* Description field removed - only available in WorkInstructionBoard
                                <div className="col-lg-4">
                                  <label className="form-label">Description</label>
                                  <textarea
                                    className="form-control"
                                    placeholder="Enter action description"
                                    value={action.description}
                                    onChange={(e) => this.handleActionChange(index, 'description', e.target.value)}
                                    rows="2"
                                  />
                                </div>
                                */}
                                <div className="col-lg-1">
                                  <label className="form-label">Step</label>
                                  <input
                                    type="text"
                                    className="form-control text-center"
                                    placeholder="1"
                                    value={action.step}
                                    onChange={(e) => this.handleActionChange(index, 'step', e.target.value)}
                                    maxLength="1"
                                    style={{ fontSize: '14px', fontWeight: 'bold' }}
                                  />
                                </div>
                                <div className="col-lg-2">
                                  <label className="form-label">&nbsp;</label>
                                  <div>
                                    <button
                                      type="button"
                                      className="btn btn-danger btn-sm"
                                      onClick={() => this.removeAction(index)}
                                    >
                                      <IoMdTrash />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-lg-2 col-form-label">Note</label>
                      <div className="col-lg-10">
                        <textarea
                          className="form-control"
                          placeholder="Enter additional notes"
                          name="note"
                          value={data.note}
                          onChange={this.handleChange}
                          rows="3"
                        />
                        {errors.note && (
                          <div className="alert alert-danger mt-1">{errors.note}</div>
                        )}
                      </div>
                    </div>

                    {this.props.currentUser?.role?.name === "Company" && company?.isMaster === true && (
                      <div className="form-group row">
                        <label className="col-lg-4 col-form-label" htmlFor="deployTo">
                          deployTo
                        </label>
                        <div className="col-lg-8">
                          <Select
                            isMulti
                            name="deployTo"
                            options={deployToOptions}
                            formatOptionLabel={this.formatOptionLabel}  // Custom rendering
                            placeholder={"Share with ..."}
                            value={deployToOptions?.filter((opt) =>
                              data?.deployTo?.includes(opt.value)
                            )}
                            onChange={(e) => this.handleMultiChange("deployTo", e)}
                          />
                        </div>
                      </div>
                    )}
                    <div className="form-group row">
                      <div className="col-lg-12">
                        <button
                          type="submit"
                          disabled={this.state.isSubmitting}
                          className="btn btn-primary"
                        >
                          {this.state.isSubmitting ? 'Submitting...' : 'Submit'}
                        </button>
                      </div>
                    </div>
                  </form>
                </PanelBody>
              </Panel>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  currentUser: getCurrentUser(state)
});

const mapDispatchToProps = (dispatch) => ({
  loadCurrentUser: (id) => dispatch(loadCurrentUser(id))
});


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(WorkInstruction));



